<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pXO5wG/tc-custom/9780547501673.jpg?1705766094750" alt="This image is the cover for the book Retrospective"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Retrospective
      </h1>
      <p class="bookDescription body article font2">
        <b>An ageing film director must face his past in the acclaimed Israeli author’s prize-winning novel—“a compelling meditation on art, memory, love [and] guilt” (<i>Independent</i>, UK).</b><br/><br/> Yair Moses, an aging Israeli film director, has been invited to the Spanish pilgrimage city of Santiago de Compostela for a retrospective of his work. Accompanied by Ruth, his leading actress and longtime muse, Moses discovers a painting in their hotel room that triggers a distant memory from one of his early films: a scene that caused a rift with his brilliant but difficult screenwriter—who, as it happens, was once Ruth’s lover.<br/><br/> Upon their return to Israel, Moses decides to travel to the south to look for his elusive former partner and propose a new collaboration. But the screenwriter demands a price that will have strange and lasting consequences. A searching and original novel by one of the world’s most esteemed writers, <i>The Retrospective </i>is a meditation on mortality and intimacy, on the limits of memory and the struggle of artistic creation.<br/><br/><b>Winner, 2012 Prix Médicis étranger</b><br/><b>Winner, 2012 Prix du Meilleur Livre Étranger</b><br/><b>A<i> New York Times Book Review</i> Editor's Choice</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        A. B. Yehoshua
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?02e9c680